/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

// react and redux
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
//
import { getInstanceExport } from 'src/app/actions';
import { singleResource } from 'src/app/actions';
// BASE components
import _ from '../../../../@lodash';
import BASELoading from '../../../../@BASE/core/BASELoading';
import BASEPageSimple from '../../../../@BASE/core/BASEPageSimple';
import useThemeMediaQuery from '../../../../@BASE/hooks/useThemeMediaQuery';

// material-ui components
import { styled } from '@mui/material/styles';
// custom components
import AnswerKeyHeader from '../../../shared-components/AnswerKeyHeader';
// PDF
import { AnswerKeyDoc } from '../../../shared-components/AnswerKeyDoc';

// styles to add to the page layout
const Root = styled(BASEPageSimple)(({ theme }) => ({
  '& .BASEPageSimple-header': {
    backgroundColor: theme.palette.background.royalBlue,
    color: theme.palette.getContrastText(theme.palette.primary.main)
  },
  '& .html-reset ul, & .html-reset ol': {
    listStyle: 'auto',
    margin: 'revert',
    padding: 'revert'
  }
}));

const LessonAnswers = () => {
  // dispatch
  const dispatch = useDispatch();
  // route params
  const routeParams = useParams();
  const { id: lessonId } = routeParams;

  const [exportData, setExportData] = useState(null);

  const [loading, setLoading] = useState(true);
  const [loadingPhase, setLoadingPhase] = useState(
    `Fetching ${singleResource('lessons')} data`
  );
  const [error, setError] = useState(null);

  // fetch the export data
  const handleFetchExportData = async () => {
    try {
      // Get the export data
      let response = await dispatch(
        getInstanceExport('lessons')(lessonId),
        'get'
      ).unwrap();
      setExportData(response);
      // Set the loading phase to indicate that the data is being processed
      setLoadingPhase('Processing completed');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!lessonId) return;
    handleFetchExportData();
  }, [lessonId]);

  // Was this ever used?
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

  // if lesson is null return loading
  if (!exportData) {
    return <BASELoading />;
  }

  const getDIR = (label = null) => {
    if (label === null) return;

    if (label.split('-')[0].toUpperCase() === 'AD') return 'rtl';
    else return 'ltr';
  };

  const dir = getDIR(exportData.course.language.acronym);

  // return lesson view
  return (
    <Root
      header={
        <AnswerKeyHeader
          back_title="Lesson"
          back={`/lessons/${routeParams.id}`}
        />
      }
      content={<AnswerKeyDoc data={exportData} dir={dir} />}
      scroll="normal"
    />
  );
};

export default LessonAnswers;
